{
  "salon-booking-config-page": {
    "buttons": {
      "book": "BUCHEN"
    },
    "text": {
      "black-listed": "Ihre Online-Buchungsoption bei diesem Salon ist gesperrt. Bitte kontaktieren Sie den Salon, um einen neuen Termin zu buchen",
      "not-found-available-time": "Wenn Sie die gewünschte Zeit nicht finden können, rufen Sie uns bitte unter der folgenden Rufnummer an"
    }
  }
}
